export const BANNER_THEMES = {
  Welcome: "", // default theme
  Api: "Api",
};
